import { WorkspaceAddressPublic } from 'shared';

export function getCityString(address: WorkspaceAddressPublic): string {
  const neighborhoodString = address.neighborhood ? `${address.neighborhood}, ` : '';
  return `${neighborhoodString}${address.city}, ${address.region}`;
}
